"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _emotion = require("emotion");
var _reactFeather = require("react-feather");
var _propTypes = require("prop-types");
var _Button = _interopRequireDefault(require("../../atoms/Button"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype.__proto__ = superClass && superClass.prototype;
  subClass.__proto__ = superClass;
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var container = function container(primaryColor, secondaryColor, theme, font) {
  return /*#__PURE__*/(
    (0, _emotion.css)("@keyframes show{from{opacity:0;}to{opacity:1;}}font-family:", font ? font : "'Inter', sans-serif", ";.timeline{@media (max-width:768px){margin:20px 0;}}.item{display:grid;grid-template-columns:0fr 1fr;grid-gap:20px;position:relative;align-items:start;padding:20px 0;cursor:pointer;opacity:0;animation:show 0.5s ease forwards;animation-delay:0.1s;svg{color:", secondaryColor, ";z-index:1;stroke-width:4px;fill:white;transition:color ease 0.2s;}.content{h3{margin:0;line-height:0.9;color:", theme === 'dark' ? '#efefef' : '#262626', ";font-weight:400;display:flex;align-items:start;transition:color ease 0.5s;}h3 span{font-size:16px;margin-left:10px;transition:margin 0.4s ease;}p{margin:12px 0;color:", theme === 'dark' ? '#dfdfdf' : '#8c8c8c', ";}.description{margin-top:20px;color:", theme === 'dark' ? '#dfdfdf' : '#595959', ";}}&::before{position:absolute;top:-20px;left:9px;height:100%;width:2px;content:'';z-index:0;transition:background ease 0.5s;background:", secondaryColor, ";background:-webkit-linear-gradient(\n\t\t\t\tto bottom,", secondaryColor, ",", secondaryColor, "\n\t\t\t);background:linear-gradient(\n\t\t\t\tto bottom,", secondaryColor, ",", secondaryColor, "\n\t\t\t);}:first-child{::before{background:", secondaryColor, ";background:-webkit-linear-gradient(\n\t\t\t\t\tto bottom,#fff,", secondaryColor, "\n\t\t\t\t);background:linear-gradient(\n\t\t\t\t\tto bottom,transparent,", secondaryColor, "\n\t\t\t\t);}}:last-child{::before{height:40%;background:", secondaryColor, ";background:-webkit-linear-gradient(\n\t\t\t\t\tto bottom,", secondaryColor, ",", secondaryColor, "\n\t\t\t\t);background:linear-gradient(\n\t\t\t\t\tto bottom,", secondaryColor, ",", secondaryColor, "\n\t\t\t\t);}}&:hover{h3{color:", primaryColor, ";}svg{color:", primaryColor, ";}h3 span{margin-left:15px;}&::before{background:", primaryColor, ";background:-webkit-linear-gradient(\n\t\t\t\t\tto bottom,", secondaryColor, ",", primaryColor, ",", secondaryColor, "\n\t\t\t\t);background:linear-gradient(\n\t\t\t\t\tto bottom,", secondaryColor, ",", primaryColor, ",", secondaryColor, "\n\t\t\t\t);}:first-child{::before{background:", secondaryColor, ";background:-webkit-linear-gradient(\n\t\t\t\t\t\tto bottom,transparent,", primaryColor, ",", secondaryColor, "\n\t\t\t\t\t);background:linear-gradient(\n\t\t\t\t\t\tto bottom,transparent,", primaryColor, ",", secondaryColor, "\n\t\t\t\t\t);}}:last-child{::before{background:", secondaryColor, ";background:-webkit-linear-gradient(\n\t\t\t\t\t\tto bottom,", secondaryColor, ",", primaryColor, "\n\t\t\t\t\t);background:linear-gradient(\n\t\t\t\t\t\tto bottom,", secondaryColor, ",", primaryColor, "\n\t\t\t\t\t);}}}}")
  );
};
var getStringTime = function getStringTime(time) {
  var hour = parseInt(time / 60, 10);
  var minutes = time % 60;
  if (hour && minutes) {
    return hour + " hr " + minutes + " min";
  }
  if (hour) {
    return hour + " hr";
  }
  return minutes + " mins";
};
var Timeline = /*#__PURE__*/
function (_React$Component) {
  function Timeline(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleShowItems", function (e) {
      e.preventDefault();
      _this.setState(function (prevState) {
        return {
          hideAll: !prevState.hideAll
        };
      });
    });
    var items = props.items,
      itemsToShow = props.itemsToShow;
    var hideAll = items.length > itemsToShow;
    _this.state = {
      hideAll: hideAll
    };
    return _this;
  }
  var _proto = Timeline.prototype;
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.items.length !== this.props.items.length) {
      var _this$props = this.props,
        items = _this$props.items,
        itemsToShow = _this$props.itemsToShow;
      var hideAll = items.length > itemsToShow; // eslint-disable-next-line

      this.setState({
        hideAll: hideAll
      });
    }
  };
  _proto.render = function render() {
    var _this$props2 = this.props,
      items = _this$props2.items,
      primaryColor = _this$props2.primaryColor,
      secondaryColor = _this$props2.secondaryColor,
      _onClick = _this$props2.onClick,
      itemsToShow = _this$props2.itemsToShow,
      theme = _this$props2.theme,
      font = _this$props2.font;
    var hideAll = this.state.hideAll;
    return (
      // eslint-disable-next-line
      _react.default.createElement("div", {
        className: container(primaryColor, secondaryColor, theme, font)
      }, _react.default.createElement("div", {
        className: "timeline"
      }, items.map(function (chapter, index) {
        if (hideAll && index > itemsToShow - 1) {
          return null;
        }
        return (
          // eslint-disable-next-line
          _react.default.createElement("div", {
            className: "item",
            key: chapter.title,
            onClick: function onClick() {
              return _onClick && _onClick(chapter);
            }
          }, _react.default.createElement(_reactFeather.Circle, {
            size: 20
          }), _react.default.createElement("div", {
            className: "content"
          }, _react.default.createElement("h3", null, chapter.title, " ", _react.default.createElement("span", null, "\u2192")), chapter.duration && _react.default.createElement("p", null, getStringTime(chapter.duration)), chapter.subtitle && _react.default.createElement("p", null, chapter.subtitle), chapter.description && _react.default.createElement("div", {
            className: "description"
          }, chapter.description)))
        );
      })), items.length - itemsToShow > 0 && _react.default.createElement(_Button.default, {
        style: {
          zIndex: 2,
          background: primaryColor,
          color: 'white'
        },
        shadow: true,
        onClick: this.handleShowItems
      }, hideAll ? "Show " + (items.length - itemsToShow) + " more" : 'Hide items'))
    );
  };
  _inheritsLoose(Timeline, _React$Component);
  return Timeline;
}(_react.default.Component);
Timeline.defaultProps = {
  itemsToShow: 3,
  primaryColor: '#7136d5',
  secondaryColor: '#d9d9d9',
  theme: 'light',
  font: ''
};
Timeline.propTypes = {
  itemsToShow: _propTypes.number,
  secondaryColor: _propTypes.string,
  primaryColor: _propTypes.string,
  items: _propTypes.array,
  onClick: _propTypes.func,
  theme: _propTypes.string,
  font: _propTypes.string
};
var _default = Timeline;
exports.default = _default;